import { IFilteredTraysListVM } from '../../models/response/IFilteredTraysResponse';
const initialProcessState: IFilteredTraysListVM = {
  AssignTrayTagList: [],
  PagingDetails: {
    TotalRecords: 0,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 0
  }
};

export default initialProcessState;
